import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CertificateTypeComponent } from './components/certificate-type/certificate-type.component';
import { ConstructionElementTypeComponent } from './components/construction-element-type/construction-element-type.component';
import { CostTypeComponent } from './components/cost-type/cost-type.component';
import { FrameMaterialComponent } from './components/frame-material/frame-material.component';
import { GlassCoatingCodeComponent } from './components/glass-coating-code/glass-coating-code.component';
import { GlassManufacturerComponent } from './components/glass-manufacturer/glass-manufacturer.component';
import { GlassTypeComponent } from './components/glass-type/glass-type.component';
import { GlassUnitComponent } from './components/glass-unit/glass-unit.component';
import { InstituteComponent } from './components/institute/institute.component';
import { InstituteTypeComponent } from './components/institute-type/institute-type.component';
import { OrganisationalUnitComponent } from './components/organisational-unit/organisational-unit.component';
import { PartnerComponent } from './components/partner/partner.component';
import { PartnerTypeComponent } from './components/partner-type/partner-type.component';
import { PerformanceCriteriaComponent } from './components/performance-criteria/performance-criteria.component';
import { ProjectConfidentialityLevelComponent } from './components/project-confidentiality-level/project-confidentiality-level.component';
import { ProjectOwnerTypeComponent } from './components/project-owner-type/project-owner-type.component';
import { ProjectPurposeComponent } from './components/project-purpose/project-purpose.component';
import { ProjectStatusComponent } from './components/project-status/project-status.component';
import { RegionComponent } from './components/region/region.component';
import { StandardComponent } from './components/standard/standard.component';
import { TestPurposeComponent } from './components/test-purpose/test-purpose.component';
import { TestTypeComponent } from './components/test-type/test-type.component';
import { GroupTypeComponent } from './components/group-type/group-type.component';
import { GroupComponent } from './components/group/group.component';
import { CountryComponent } from './components/country/country.component';
import { TestTypeStandardComponent } from './components/test-type-standard/test-type-standard.component';
import { CertificateTypeStandardComponent } from './components/certificate-type-standard/certificate-type-standard.component';
import { SaveStandardComponent } from './components/save-standard/save-standard.component';
import { SavePerformanceCriteriaComponent } from './components/save-performance-criteria/save-performance-criteria.component';
import { FrameNameComponent } from './components/frame-name/frame-name.component';
import { FrameComponent } from './components/frame/frame.component';
import { SaveFrameComponent } from './components/save-frame/save-frame.component';
import { ResultFailureReasonComponent } from './components/result-failure-reason/result-failure-reason.component';
import { ResultUnitComponent } from './components/result-unit/result-unit.component';
import { ComponentCausedFailureComponent } from './components/component-caused-failure/component-caused-failure.component';
import { BeadPositionComponent } from './components/bead-position/bead-position.component';
import { MountingDirectionComponent } from './components/mounting-direction/mounting-direction.component';
import {SupportingConstructionComponent } from './components/supporting-construction/supporting-construction.component';
import { GlassBehaviourComponent } from './components/glass-behaviour/glass-behaviour.component';

const routes: Routes = [
  {path : '', component : CertificateTypeComponent},  
  {path : 'certificatetype', component :CertificateTypeComponent},  
  {path : 'constructionElementType', component : ConstructionElementTypeComponent},
  {path : 'costType', component :CostTypeComponent},
  {path : 'country', component : CountryComponent},
  {path : 'frame', component : FrameComponent},
  {path : 'frameName', component : FrameNameComponent},
  {path : 'frameMaterial', component : FrameMaterialComponent},
  {path : 'glassCoatingCode', component : GlassCoatingCodeComponent},  
  {path : 'glassManufacturer', component : GlassManufacturerComponent},
  {path : 'glassType', component : GlassTypeComponent},
  {path : 'glassUnit', component : GlassUnitComponent},
  {path : 'resultUnit', component : ResultUnitComponent},
  {path : 'beadPosition', component : BeadPositionComponent},
  {path : 'componentCausedFailure', component : ComponentCausedFailureComponent},
  {path : 'groupType', component : GroupTypeComponent},
  {path : 'group', component : GroupComponent},
  {path : 'institute', component : InstituteComponent},
  {path : 'instituteType', component : InstituteTypeComponent},
  {path: 'mountingDirection', component: MountingDirectionComponent},
  {path: 'glassBehavior', component: GlassBehaviourComponent},
  {path : 'organisationalUnit', component : OrganisationalUnitComponent},
  {path : 'partner', component : PartnerComponent},
  {path : 'partnerType', component : PartnerTypeComponent},
  {path : 'performanceCriteria', component : PerformanceCriteriaComponent},
  {path : 'projectConfidentiality', component : ProjectConfidentialityLevelComponent},
  {path : 'projectOwnerType', component : ProjectOwnerTypeComponent},
  {path : 'projectPurpose', component : ProjectPurposeComponent},
  {path : 'projectStatus', component : ProjectStatusComponent},
  {path : 'region', component : RegionComponent},
  {path : 'standard', component : StandardComponent},
  {path : 'testPurpose', component : TestPurposeComponent},
  {path : 'testType', component : TestTypeComponent},
  {path: 'testTypeStandard', component: TestTypeStandardComponent},
  {path: 'testTypeStandard/:id', component: TestTypeStandardComponent},
  {path: 'certificateTypeStandard', component: CertificateTypeStandardComponent},
  {path: 'certificateTypeStandard/:id', component: CertificateTypeStandardComponent},
  {path: 'save-standard/:id', component: SaveStandardComponent},
  {path: 'save-standard', component: SaveStandardComponent},
  {path: 'save-performance-criteria', component: SavePerformanceCriteriaComponent},
  {path: 'save-performance-criteria/:id', component: SavePerformanceCriteriaComponent},
  {path: 'save-frame', component: SaveFrameComponent},
  {path: 'save-frame/:id', component: SaveFrameComponent},
  {path: 'frame', component: FrameComponent},
  {path: 'result-failure', component: ResultFailureReasonComponent},
  {path: 'supportingConstruction', component: SupportingConstructionComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
